@use "ui/styles/colors";

.prospect {
  color: colors.$gray70;
}

.contract {
  color: colors.$blue;
}

.testing {
  color: colors.$greenDark;
}

.closed {
  color: colors.$gray95;
}
